// components/SSDSection.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import sanityClient from "../sanityClient";
import styled from "styled-components";
import ssdImage from "../assets/ssd.jpg";

const Section = styled.section`
  width: 100%;
  background: #f9f4ec;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 16px;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }

  @media (max-width: 480px) {
    padding: 32px 12px;
  }
`;

const CardArea = styled.div`
  width: 100%;
  max-width: 1102.5px;
  border-radius: 36px;
  background-image: url(${ssdImage});
  background-size: cover;
  background-position: center;
  padding: 48px 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 40px 32px;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 32px 24px;
    gap: 16px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  max-width: 500px;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`;

const Heading = styled.h3`
  font-family: "Poppins";
  font-weight: 600;
  font-size: 36px;
  line-height: 54px;
  color: #ffffff;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 40px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
    line-height: 32px;
  }
`;

const DescriptionText = styled.p`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #afb6d2;
  margin: 0;
  max-width: 100%;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

const GradientDemoButton = styled.button`
  min-width: 250px;
  height: 54px;
  border-radius: 16px;
  padding: 13.5px 24px;
  background: linear-gradient(
    106.71deg,
    #c69957 0%,
    #f7e096 47.6%,
    #a57632 93.27%
  );
  color: #1c1b19;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  text-transform: capitalize;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: opacity 0.3s ease;

  svg {
    margin-left: 8px;
  }

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    min-width: 200px;
    padding: 12px 20px;
  }
`;

const SSDSection = () => {
  const navigate = useNavigate();
  const [ctaData, setCtaData] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "callToActionSection"][0]`)
      .then(setCtaData)
      .catch((error) => console.error("❌ CTA fetch error:", error));
  }, []);

  return (
    <Section>
      <CardArea>
        <Content>
          <Heading>{ctaData?.heading || "Measure What Matters"}</Heading>
          <DescriptionText>
            {ctaData?.description ||
              "Neuora turns real-world behavior into real business growth..."}
          </DescriptionText>
        </Content>
        <GradientDemoButton onClick={() => navigate("/contact")}>
          BOOK DEMO
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </GradientDemoButton>
      </CardArea>
    </Section>
  );
};

export default SSDSection;
